import BreakpointsContainer from '~/components/BreakpointsContainer';
import type { Publication, WebThemeV2 } from '~/interfaces/publication';

import LogoHome from '../Nav/LogoHome';
import Menu from '../Nav/Menu';
import MenuActions from '../Nav/MenuActions';

interface Props {
  publication: Publication;
  showActions: boolean;
  theme: WebThemeV2;
}

const Template1 = ({ publication, showActions, theme }: Props) => {
  return (
    <BreakpointsContainer
      as="nav"
      className="w-full py-2"
      style={{
        backgroundColor: theme?.navbar_background_color,
      }}
    >
      <div className="mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <LogoHome
            fontFamily={theme.navbar_font_family}
            url={publication.logo.thumb.url}
            name={publication.name}
            textColor={theme.navbar_text_color}
          />
          <Menu publication={publication} theme={theme} />
        </div>

        <MenuActions ctaText={publication.cta_text} showActions={showActions} publication={publication} />
      </div>
    </BreakpointsContainer>
  );
};

export default Template1;
